import { Routes, Route, Navigate } from 'react-router-dom';
import { ProjectScope } from '../../components/ProjectScope';
import { Dashboard } from './Dashboard';
import { Contracts } from './Contracts';
import { ContractDetail } from './ContractDetail';
import { Certificate } from './Certificate';

export function CostRoutes() {
  return (
    <ProjectScope
      storageKey="munin.cost.project"
      emptyBody="Cost assurance menggantung pada sebuah proyek dan kontraknya. Buat proyek lebih dulu."
    >
      {(projectId) => (
        <Routes>
          <Route path="/" element={<Dashboard projectId={projectId} />} />
          <Route path="/contracts" element={<Contracts projectId={projectId} />} />
          <Route path="/contracts/:id" element={<ContractDetail projectId={projectId} />} />
          <Route path="/certificates/:id" element={<Certificate />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      )}
    </ProjectScope>
  );
}
